import moment from "moment";
import { amountFormat } from "../services/common.service";
import { ReactComponent as DownloadIcon } from "../assests/icons/download.svg";
import { Button, Empty } from "antd";
import { useTranslation } from "react-i18next";

export default function GepgHistoryGrid({
  dataSource = [],
  handleDownload,
  setDetails,
  setVisible,
  hasMoreRecords,
  fetchMoreHistory,
}) {
  const { t } = useTranslation();

  return (
    <>
      {dataSource.length === 0 ? (
        <Empty
          description={t("pages.transfer_limit.no_record_found", {
            defaultValue: "No Record found",
          })}
        />
      ) : (
        <div className="ft-table">
          <table className="table">
            <thead style={{ backgroundColor: "#F1F1F1" }}>
              <tr>
                <th>
                  {t("pages.gepeg.source_account", {
                    defaultValue: "Source Account",
                  })}
                </th>
                <th>
                  {t("pages.gepeg.bill_control_no", {
                    defaultValue: "Bill Control No",
                  })}
                </th>
                <th>
                  {t("pages.gepeg.bill_currency", {
                    defaultValue: "Bill Currency",
                  })}
                </th>
                <th>
                  {t("common.transaction_date", {
                    defaultValue: "Transaction Date",
                  })}
                </th>
                <th>
                  {t("pages.gepeg.paid_amount", {
                    defaultValue: "Paid Amount",
                  })}
                </th>
                <th>{t("common.status", { defaultValue: "Status" })}</th>
              </tr>
            </thead>
            <tbody>
              {dataSource.map((option, idx) => (
                <tr
                  key={idx}
                  onClick={() => {
                    setDetails(option);
                    setVisible(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <td>
                    <span
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleDownload(option);
                      }}
                    >
                      <span className="refspan">
                        {option.debitAccount || "-"}
                      </span>

                      <DownloadIcon
                        height={18}
                        style={{ marginLeft: "10px" }}
                      />
                    </span>
                  </td>
                  <td>{option.controlNum || "-"}</td>
                  <td>{option.billCcy || "-"}</td>
                  <td>
                    {option?.initDate && (
                      <span>
                        {moment(option?.initDate).format("DD-MM-YYYY") || "-"}
                      </span>
                    )}
                  </td>
                  <td>{amountFormat(option.paidAmount, option?.debitCcy)}</td>
                  <td>
                    {option?.status === "SUCCESS" ? (
                      <span className="success-text px-2 py-1">
                        {" "}
                        {t("common.success_cap", {
                          defaultValue: "SUCCESS",
                        })}
                      </span>
                    ) : option?.status == null ? (
                      <span className="px-2 py-1">-</span>
                    ) : (
                      <span className="fail-error px-2 py-1">
                        {option?.status || "-"}
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {hasMoreRecords && (
        <div align="center" className="mt-3">
          <Button type="default" onClick={() => fetchMoreHistory()}>
            {t("buttons.load_more_records_btn", {
              defaultValue: "Load More Records",
            })}
          </Button>
        </div>
      )}
    </>
  );
}
